<template>
    <div class="account-tap">
        <Search @search="getData" class="w-100 p-0" />
        <b-overlay :show="apiLoading" rounded="sm" spinner-variant="primary">
            <div class="list">
                <Card v-for="(item, index) in list" :key="index" :data="item"/>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import Search from "./Search";
import Card from "../tap/Card";

export default {
    name: "Index",
    components: {Card, Search},
    data() {
        return {
            list: [],
            apiLoading: false
        }
    },
    methods: {
        getData(text = '') {
            this.apiLoading = true
            $.ajax({
                method: "GET",
                url: '/taps/my_taps?per_page=200&search=' + text
            }).then(res => {

                this.list = res.data.data
            }).always(() => {
                this.apiLoading = false
            });
        }
    },
    mounted() {
        this.getData()
    }
}
</script>

<style lang="scss" scoped>
.account-tap {
    padding: 30px;
    padding-top: 0;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .list {
        display: flex;
        gap: 10px;
        flex-direction: column;

    }
}
</style>
